import { getExternalConnectionCalendars as _getExternalConnectionCalendars } from '@griply/services';
import { ExternalCalendar, ID } from '@griply/types';
import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

export const getExternalConnectionCalendars = (
  externalConnectionId: ID,
): Promise<ExternalCalendar[]> =>
  _getExternalConnectionCalendars({
    functions: getFunctions(),
    httpsCallable,
    payload: { externalConnectionId },
  });
